import Component from "./ProgramStatusIcon";

export default Component;
